import { createColumnHelper } from '@tanstack/react-table'
import { ImportStatus, StatusFile } from '@/core/types/graphql'
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import React from 'react'
import { statusTag } from '../utils/status-style'

const columnHelper = createColumnHelper<ImportStatus>()

const getStatus = (status: StatusFile) => {
  const map = {
    [StatusFile.Error]: t`Erro`,
    [StatusFile.Processing]: t`Em processamento`,
    [StatusFile.Received]: t`Recebido`
  }
  return map[status]
}

export const columnsTableImportStatus = () => {
  return [
    columnHelper.display({
      id: 'name',
      header: t`Nome do arquivo`,
      cell: ({ row: { original: status } }) => {
        return <p className={'font-bold'}>{status.fileName}</p>
      }
    }),
    columnHelper.display({
      id: 'progress',
      header: t`Progresso`,
      cell: ({ row: { original: status } }) => {
        return (
          <div>
            <p>
              <Trans>
                <span className={'font-bold'}>Andamento: </span>
                {status.progress?.toFixed(2)}%
              </Trans>
            </p>
            <p>
              <Trans>
                <span className={'font-bold'}>Total: </span> {status.total}
              </Trans>
            </p>
            <p>
              <Trans>
                <span className={'font-bold'}>Finalizados: </span>
                {status.done}
              </Trans>
            </p>
          </div>
        )
      }
    }),
    columnHelper.display({
      id: 'status',
      header: t`Status`,
      cell: ({ row: { original: status } }) => {
        return (
          <div className={statusTag({ status: status.status as StatusFile })}>
            <p className={'text-white font-bold'}>
              {getStatus(status.status as StatusFile)}
            </p>
          </div>
        )
      }
    })
  ]
}
